<template>
  <div class="link-card">
    <div class="link-image">
      <div class="image-wrapper">
        <img :src="link.image" :alt="link.title" />
        <template v-if="isRelease">
          <TrackIcon class="icon extra-small" />
        </template>
        <template v-if="isBio">
          <ProfileIcon class="icon extra-small" />
        </template>
        <template v-if="isPlaylist">
          <PlaylistIcon class="icon extra-small" />
        </template>
      </div>
    </div>
    <div class="link-details">
      <div class="left">
        <span @click="openLink(link)" class="link-title">{{ link.title }}</span>
        <span class="link-type">{{
          link.type
            ? link.type.charAt(0).toUpperCase() + link.type.slice(1)
            : ""
        }}</span>
        <div class="link-url">
          <div class="url-box">
            <span class="url-text">{{ link.domain }}/{{ link.path }}</span>
            <span
              v-clipboard:copy="'https://' + link.domain + '/' + link.path"
              v-clipboard:success="onCopy"
              class="copy"
            >
              <CopyIcon />
            </span>
          </div>
        </div>
      </div>
      <div class="right">
        <div class="views">
          <ViewIcon />
          <span class="view-count">{{
            totals ? totals.views.toLocaleString("en-US") : "-"
          }}</span>
        </div>
        <div class="clicks">
          <ClickIcon />
          <span class="click-count">{{
            totals ? totals.clicks.toLocaleString("en-US") : "-"
          }}</span>
        </div>
        <button @click="openLink(link)" class="button-default open-link">
          <ArrowRightIcon />
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import TrackIcon from "../../../public/img/icons/categories/track.svg";
import ProfileIcon from "../../../public/img/icons/categories/profile.svg";
import PlaylistIcon from "../../../public/img/icons/categories/playlist.svg";
import ArrowRightIcon from "../../../public/img/icons/arrow-right.svg";
import ViewIcon from "../../../public/img/icons/view.svg";
import ClickIcon from "../../../public/img/icons/click.svg";
import CopyIcon from "../../../public/img/icons/copy.svg";
export default {
  name: "SmartLinkCard",
  props: ["link", "totals"],
  components: {
    ArrowRightIcon,
    ViewIcon,
    ClickIcon,
    CopyIcon,
    TrackIcon,
    ProfileIcon,
    PlaylistIcon
  },
  computed: {
    artist() {
      return this.$store.getters.getArtist;
    },
    isRelease() {
      return !this.link.link_type || this.link.link_type === "release";
    },
    isBio() {
      return this.link.link_type === "bio";
    },
    isPlaylist() {
      return this.link.link_type === "playlist";
    }
  },
  methods: {
    openLink(link) {
      this.$router.push({ name: "SmartLink", params: { id: link.id } });
    },
    async onCopy() {
      await this.$store.dispatch("snack", {
        text: "Copied to clipboard"
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.link-card {
  display: flex;
  padding: 18px;
  /* BG/type2 */
  background: $bg-type-2;
  /* Shadow */
  //box-shadow: 0px 50px 40px rgba(23, 18, 43, 0.3);
  border-radius: 10px;
  transition: all 0.3s ease-in-out;
  /* &:hover { */
  //transform: scale(1.005);
  //border: 1px solid white;
  /* } */
  .link-image {
    width: 100px;
    height: 100px;
    box-shadow: none;
    img {
      border-radius: 10px;
      width: 100px;
      height: 100px;
      object-fit: cover;
    }
    svg {
      width: 15px;
      position: absolute;
      top: 7px;
      left: 7px;
      path {
        fill: white;
      }
    }
    .image-wrapper {
      position: relative;
      width: 100px;
    }
  }
  .link-details {
    display: flex;
    flex: 1;
    max-width: calc(100% - 100px);
    .left {
      flex: 1;
      margin-left: 12px;
      display: flex;
      flex-direction: column;
      .link-title {
        cursor: pointer;
        margin-top: 6px;
        /* 18/SemiBold */
        font-weight: 600;
        font-size: 18px;
        line-height: 30px;
        /* White */
        color: white;
      }
      .link-type {
        /* 12/Regular */
        font-size: 12px;
        line-height: 18px;
        /* Text/type1 */
        color: $text-type-1;
        mix-blend-mode: normal;
        opacity: 0.9;
      }
      .link-url {
        margin-top: 16px;
        width: max-content;
        max-width: 100%;
        .url-box {
          display: flex;
          align-items: center;
          background: rgba(27, 25, 60, 0.5);
          border-radius: 5px;
          padding: 6px;
          gap: 5px;
          .url-text {
            display: inline-block;
            overflow: hidden;
            text-overflow: ellipsis;
            font-size: 14px;
            line-height: 17px;
            color: $text-type-0;
          }
          .copy {
            display: inline-block;
            &:hover {
              svg {
                path {
                  fill: white;
                }
              }
            }
            svg {
              cursor: pointer;
              width: 18px;
              height: 18px;
              path {
                fill: #8786ab;
              }
            }
          }
        }
      }
    }
    .right {
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      .views {
        background: rgba(27, 25, 60, 0.75);
        border-radius: 5px;
        padding: 6px;
        display: flex;
        align-items: center;
        margin-bottom: 6px;
        svg {
          width: 12px;
          //height: 18px;
          path {
            fill: #8786ab;
          }
        }
        span {
          margin-left: 7px;
          /* 10/SemiBold */
          font-weight: 600;
          font-size: 10px;
          line-height: 12px;
          /* Text/type1 */
          color: $text-type-1;
        }
      }
      .clicks {
        background: rgba(27, 25, 60, 0.75);
        border-radius: 5px;
        padding: 6px;
        display: flex;
        align-items: center;
        margin-bottom: 6px;
        svg {
          width: 12px;
          //height: 18px;
          path {
            fill: #8786ab;
          }
        }
        span {
          margin-left: 7px;
          /* 10/SemiBold */
          font-weight: 600;
          font-size: 10px;
          line-height: 12px;
          /* Text/type1 */
          color: $text-type-1;
        }
      }
      .open-link {
        margin-top: 10px;
        width: 30px;
        height: 30px;
        padding: 0;
        border-radius: 40px;
        svg {
          width: 18px;
          margin-left: 0;
        }
      }
    }
  }
}
@media (max-width: 600px) {
  .link-card {
    align-items: center;
    .link-details {
      flex-direction: column;
      .right {
        flex-direction: row-reverse !important;
        width: max-content;
        margin-left: 12px;
        margin-top: 20px;
        align-items: center !important;
        
        gap: 12px;
        .open-link {
          margin-top: 0 !important;
        }
        .clicks, .views {
          margin-bottom: 0 !important;
        }
      }
      .link-title {
        font-size: 15px !important;
        margin-top: 0 !important;
        line-height: 20px !important;
      }
    }
  }
}
</style>
